<template>
  <div id="app">
    <router-view></router-view>
    <noticeDialog :visible="is_notice_state" @submit="submit"> </noticeDialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import swal from '@/utils/swal';
import noticeDialog from '@/components/notice/index.vue';
import { initXesAnalytics } from '@/utils/buryingPoint';
export default {
  name: 'app',
  components: {
    noticeDialog,
  },
  mounted() {
    // this.$store.dispatch('init')
    // .then(() => {
    let hash = window.location.hash;
    if (hash.indexOf('jslist') !== -1) {
      this.$store.dispatch('initUserInfo', true);
      return;
    }
    // this.$store.dispatch('init')
    // .then(() => {
    this.certificateInit(this.id);
    // });
    window.addEventListener('message', this.receiveMessage, false);
  },

  created() {
    initXesAnalytics(process.env.NODE_ENV === 'development');
  },

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage, false);
  },
  computed: mapState({
    id: (state) => state.router.id,
    is_notice_state: (state) => state.user.isNoticeState,
  }),

  methods: {
    ...mapActions('certificate', ['certificateInit']),
    receiveMessage(evt) {
      try {
        const { type } = JSON.parse(evt.data);

        if (type === 'XH_INVOKE_LOGIN') {
          swal.offlinePrompt().then(() => this.$store.dispatch('LogOut'));
        }
      } catch (err) {
        // console.log(err);
      }
    },
    submit({ type }) {
      let is_notice_state = type === 'cancel' ? false : true;
      this.$store.dispatch('setNoticeState', false);
      if (!is_notice_state) this.$store.dispatch('golbalNotice', this.id);
      if (is_notice_state) window.location.reload();
    },
  },
};
</script>

<style>
#app {
  height: 100%;
}
</style>
